import { ChangeLinkArgs } from './Types'

export const removeLink =
  ({ view, linkPosition }: ChangeLinkArgs) =>
  () => {
    const tx = view.state.tr.removeMark(linkPosition.from, linkPosition.to)

    view.dispatch(tx)
    view.focus()
  }
